module.exports = __webpack_public_path__ + "img/landingInteractions.0fef0ce6.jpg";